import type {CompleteFinancialProductPreferenceCoordinates} from '../schemas/CompleteFinancialProductPreferenceCoordinatesSchema';
import type {FinancialProductPreferenceCoordinates} from '../schemas/FinancialProductPreferenceCoordinatesSchema';
import type {UpdateFinancialProductPreferenceRequestBody} from '../schemas/UpdateFinancialProductPreferenceRequestBodySchema';

const EMPTY_COORDINATES = {
  termMonths: null,
  downPaymentPercentage: null,
  balloonPaymentPercentage: null,
  leasingTargetGroup: null,
  annualMileage: null,
};

/** Fill absent complete-coordinate fields without normalizing supplied public coordinates. */
export const toFinancialProductPreferenceRequestBody = (
  coordinates:
    | FinancialProductPreferenceCoordinates
    | CompleteFinancialProductPreferenceCoordinates,
  expectedPreferenceRevision: number
): UpdateFinancialProductPreferenceRequestBody => ({
  ...EMPTY_COORDINATES,
  ...coordinates,
  expectedPreferenceRevision,
});
